<template lang="pug">
div
    BaseHeader(
        icon='el-icon-plus',
        exibeBotao,
        :titulo='$t("mensagens.gerenteComercial.labels.titulo")',
        :voltarPara='{ route: "ConfiguracaoRastreabilidade" }',
        :btnTexto='$t("mensagens.gerenteComercial.labels.novoGerente")',
        @btnHeaderClicado='irParaCadastroGerenteComercial'
    )
    .gerentes-comerciais
        .field
            i.el-icon-search.field__icon
            input.input-search.field__input(
                v-model='filtro',
                type='text',
                :placeholder='$t("mensagens.gerenteComercial.labels.placeholder")',
                autocomplete='off',
                @keyup.enter='listarGerentesComerciais'
            )
        .lista
            h3.lista__titulo {{ $t('mensagens.gerenteComercial.labels.listagem') }}
            el-table.lista__tabela(:key="listagemTableKey('gerentes-comerciais', lista, paginacao.pagina + 1)", :data='lista')
                el-table-column(
                    prop='id',
                    label='ID ERP',
                    width='200',
                    align='center'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.idBunge || '-' }}
                el-table-column(
                    prop='nome',
                    :label='$t("mensagens.gerenteComercial.labels.nomeLabel")'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.nome || '-' }}

                el-table-column(
                    :label='$t("mensagens.gerenteComercial.labels.acao")',
                    :min-width='15',
                    align='center'
                )
                    .template(slot-scope='scope')
                        el-dropdown.action-button(trigger='click')
                            span.el-dropdown-link
                                i.mdi.mdi-dots-vertical
                            el-dropdown-menu(slot='dropdown')
                                el-dropdown-item(
                                    icon='el-icon-view',
                                    @click.native='irParaDetalhesGerenteComercial(scope.row)'
                                ) {{ $t('mensagens.gerenteComercial.labels.visualizar') }}
                                el-dropdown-item(
                                    icon='el-icon-edit',
                                    @click.native='irParaEdicaoGerenteComercial(scope.row)'
                                ) {{ $t('mensagens.gerenteComercial.labels.editar') }}
                                el-dropdown-item(
                                    icon='el-icon-delete',
                                    @click.native='confirmarRemocaoGerente(scope.row)'
                                ) {{ $t('mensagens.gerenteComercial.labels.excluir') }}
                template(slot='empty')
                el-empty(description='Não há fornacedores')
            .paginacao
                span.total-paginas {{ formatarTotalPaginas(paginacao.total) }}
                el-pagination(
                    background,
                    layout='prev, pager, next',
                    :page-size='paginacao.itensPorPagina',
                    :current-page.sync='paginacao.pagina + 1',
                    :total='paginacao.total',
                    @current-change='listarGerentesComerciais'
                )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import services from '@/services/ContratoOriginacaoService';

export default {
    name: 'ConfiguracaoGerentesComerciais',
    components: {
        BaseHeader
    },
    data() {
        return {
            filtro: '',
            pageable: {
                page: 0,
                size: 10,
                sort: 'nome',
                order: 'asc'
            },
            lista: [],
            paginacao: {}
        };
    },
    mounted() {
        this.listarGerentesComerciais();
    },
    methods: {
        async listarGerentesComerciais(page = 1) {
            this.pageable.page = page - 1;
            const params = {
                filtro: { nome: this.filtro },
                pageable: this.pageable
            };

            const { data } = await services.buscarGerentesComercialPorFiltro(
                params
            );
            this.lista = data.gerentesComerciais;
            this.paginacao = data.paginacao;
        },
        irParaCadastroGerenteComercial() {
            this.$router.push({
                name: 'GerentesComerciaisCadastro'
            });
        },
        irParaEdicaoGerenteComercial(row) {
            this.$router.push({
                name: 'GerentesComerciaisEdicao',
                params: { row }
            });
        },
        irParaDetalhesGerenteComercial(row) {
            this.$router.push({
                name: 'GerentesComerciaisDetalhes',
                params: { resume: row }
            });
        },
        confirmarRemocaoGerente(row) {
            const confirmButtonText = this.$t('mensagens.comuns.sim');
            const cancelButtonText = this.$t('mensagens.comuns.cancelar');
            const aviso = this.$t('mensagens.comuns.aviso');
            const mensagemRemocao = this.$t(
                'mensagens.sistema.removerGerenteComercial'
            );

            return this.$messageBox
                .confirm(mensagemRemocao, aviso, {
                    confirmButtonText,
                    cancelButtonText,
                    type: 'warning'
                })
                .then(result => {
                    if (result === 'confirm') {
                        this.removerGerenteComercial(row);
                    }
                });
        },
        removerGerenteComercial(row) {
            const { id, name } = row;
            const mensagemSucesso = this.$t(
                'mensagens.gerenteComercial.labels.registroExcluido'
            );

            services.removerGerenteComercial({ id, name }).then(({ data }) => {
                if (data.includes('sucesso')) {
                    this.$notify.success(mensagemSucesso);
                    this.listarGerentesComerciais();
                }
            });
        },
        formatarTotalPaginas(total = 0) {
            const title =
                total > 1
                    ? this.$t('mensagens.gerenteComercial.labels.titulo')
                    : this.$t(
                          'mensagens.gerenteComercial.labels.tituloSingular'
                      );

            return `${total} ${title}`;
        }
    }
};
</script>

<style lang="scss" scoped>
.gerentes-comerciais {
    margin: 20px;
    .field {
        display: flex;
        background-color: $white;
        padding: 7px 10px;
        border-radius: $default-border-radius;
        gap: 5px;
        align-items: center;
        @include default-box-shadow();

        &__icon {
            color: $primary;
        }
        &__input {
            border: none;
            outline: none;
            width: 100%;
            &:focus,
            &:active {
                border: none;
            }
        }
    }
    .lista {
        margin-top: 20px;
        &__titulo {
            margin-bottom: 5px;
        }
        .el-table {
            border-radius: 4px 4px 0 0;
            @include default-box-shadow();
        }
    }
    .paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        background-color: $white;
        border-radius: 0 0 4px 4px;
        padding: 15px;

        .total-paginas {
            color: $primary;
            font-weight: bold;
        }
    }
}
</style>
